import React, { useState, useEffect } from "react";
import { useModalKeyboardHandlers } from "../../useModalKeyboardHandlers";


export default function ProcessInstabilityModal({ initialSelection = [], onClose, onSave }) {
    const [instabilityData, setInstabilityData] = useState([]);

    useEffect(() => {
        const loadInstabilities = async () => {
            try {
                const response = await fetch('/instability_options.json');
                const data = await response.json();
                setInstabilityData(data || []);
            } catch (err) {
                console.error("Failed to load instabilities:", err);
            }
        };
        loadInstabilities();
    }, []);

    const [selected, setSelected] = useState(initialSelection || []); // Array of labels or abbreviations

    const toggleSelection = (label) => {
        setSelected((prev) => {
            // Using labels as unique identifier for selection
            // Backend expects DTO with label+abbreviation
            const exists = prev.some(item => item.label === label);
            if (exists) {
                return prev.filter(item => item.label !== label);
            } else {
                const item = instabilityData.find(i => i.label === label);
                return item ? [...prev, { label: item.label, abbreviation: item.abbreviation }] : prev;
            }
        });
    };

    useModalKeyboardHandlers({
        onClose,
        onSave: () => handleSubmit({ preventDefault: () => { } }),
        dependencies: [selected],
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(selected);
        onClose();
    };

    return (
        <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} role="dialog">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <form className="modal-content shadow-lg border-0" onSubmit={handleSubmit}>
                    <div className="modal-header bg-light">
                        <h5 className="modal-title fw-bold text-dark">
                            <i className="bi bi-exclamation-triangle me-2 text-warning"></i>
                            Select Process Instability
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body p-4 bg-light-subtle">
                        <div className="row g-3">
                            {instabilityData.map(({ label, abbreviation }) => {
                                const isSelected = selected.some(s => s.label === label);
                                return (
                                    <div key={label} className="col-6">
                                        <label
                                            className={`card h-100 cursor-pointer text-center border-2 transition-all ${isSelected ? 'border-primary bg-primary-subtle' : 'border-light hover-border-secondary'
                                                }`}
                                            style={{ cursor: 'pointer', transition: 'all 0.2s' }}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={isSelected}
                                                onChange={() => toggleSelection(label)}
                                                className="d-none"
                                            />
                                            <div className="card-body p-3 d-flex align-items-center justify-content-center">
                                                <span className={`fw-bold ${isSelected ? 'text-primary' : 'text-dark'}`}>
                                                    {label}
                                                </span>
                                            </div>
                                        </label>
                                    </div>
                                );
                            })}
                        </div>

                        {instabilityData.length === 0 && (
                            <div className="text-center py-5 text-muted">
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Loading instability options...
                            </div>
                        )}
                    </div>

                    <div className="modal-footer bg-light border-top-0 py-3">
                        <button type="button" className="btn btn-outline-secondary px-4 rounded-pill fw-bold me-2" onClick={onClose}>
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-primary px-4 shadow-sm fw-bold rounded-pill">
                            <i className="bi bi-check2-circle me-1"></i>
                            Save Selection
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
